module.exports = __webpack_public_path__ + "img/square-7.dfea0354.svg";